// Imported first by index.tsx, for its side effect: personal values in the
// address bar (an email address on the sign-in and sign-up pages; the user
// name, code and email address of a verification link) must be gone before any
// analytics code loads and reads the address.
import { captureEmailPrefillFromUrl } from 'Utils/EmailPrefill';
import { captureVerificationLinkFromUrl } from 'Utils/VerificationLink';

captureEmailPrefillFromUrl();
captureVerificationLinkFromUrl();
